export async function copyText(text: string): Promise<boolean> {
  if (!navigator.clipboard) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export async function copyJson(value: unknown): Promise<boolean> {
  return copyText(JSON.stringify(value, null, 2));
}
